<div class="filters-button">
    <a *ngIf="showFiltersBtn"
       data-test="filter-button"
       role="button"
       tabindex="0"
       [attr.aria-label]="getFiltersTranslation()"
       (click)="toggleShowFilters()"
       (keyup.enter)="toggleShowFilters()"
       [ngClass]="{active: isFiltersOpen}">
        <span class="fas fa-filter" aria-hidden="true"></span>
        <span class="sr-only" translate>Toggle show filters</span>
    </a>
</div>
